import {
  Button,
  Dialog,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  Tooltip,
} from "@material-ui/core"
import React, { useState } from "react"
import { useAppDispatch } from "./store"
import { createChannel, registerChannel } from "./store/thunks"
import { SupportInfo } from "./store/types"

export interface Props {
  supportInfo: SupportInfo
}

const OptIn: React.FC<Props> = ({ supportInfo }) => {
  const dispatch = useAppDispatch()

  const register = React.useCallback(
    () => dispatch(registerChannel()),
    [dispatch]
  )
  const create = React.useCallback(() => dispatch(createChannel()), [dispatch])

  const [modalOpen, setModalOpen] = useState(false)

  const canOptIn =
    (supportInfo.isSupported || supportInfo.canRegister) &&
    supportInfo.dataCollectionEnabled

  return (
    <>
      <Tooltip title={getTooltip(supportInfo)}>
        <div>
          <Button
            data-qa-selector="opt-in-button"
            color="inherit"
            onClick={() => setModalOpen(true)}
            disabled={!canOptIn}
          >
            Opt In
          </Button>
        </div>
      </Tooltip>
      <Dialog open={modalOpen} onClose={() => setModalOpen(false)}>
        <DialogTitle>Select Opt-in Type</DialogTitle>
        <List>
          <ListItem
            autoFocus
            button
            onClick={create}
            disabled={!supportInfo.isSupported}
          >
            <ListItemText primary="Tracking Only" />
          </ListItem>
          <ListItem
            autoFocus
            button
            onClick={register}
            disabled={!supportInfo.canRegister}
          >
            <ListItemText primary="Push Notifications" />
          </ListItem>
        </List>
      </Dialog>
    </>
  )
}

function getTooltip(supportInfo: SupportInfo): string {
  if (!supportInfo.dataCollectionEnabled) return "Data collection is disabled"
  if (!supportInfo.isSupported) return "Browser is not supported"
  if (!supportInfo.canRegister) return "Not in supported registration context"
  return ""
}

export default OptIn
